import Container from './ForumSearchPage.container';
import Component from './ForumSearchPage';

export default Container(Component);
